var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 3.75,
    width: 14.5,
    height: 16.5,
    rx: 1.25,
    stroke: "#0895CB",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5859 9.7998C15.6654 9.7998 15.7445 9.81532 15.8184 9.84473C15.8915 9.87387 15.9578 9.91722 16.0146 9.97168L16.0156 9.9707C16.0733 10.0251 16.1195 10.0905 16.1514 10.1631C16.1833 10.236 16.2002 10.3149 16.2002 10.3945C16.2002 10.4742 16.1833 10.5531 16.1514 10.626C16.1195 10.6986 16.0733 10.764 16.0156 10.8184L16.0146 10.8174L11.5957 15.0283C11.3558 15.2571 10.9714 15.2571 10.7314 15.0283L8.98535 13.3623C8.92768 13.3079 8.88052 13.2435 8.84863 13.1709C8.81671 13.098 8.79982 13.019 8.7998 12.9395C8.7998 12.8598 8.81669 12.7809 8.84863 12.708C8.8805 12.6354 8.92672 12.57 8.98438 12.5156H8.98535C9.04208 12.4614 9.10871 12.4187 9.18164 12.3896C9.25546 12.3602 9.33458 12.3447 9.41406 12.3447C9.49348 12.3447 9.57272 12.3603 9.64648 12.3896C9.7198 12.4189 9.78685 12.4619 9.84375 12.5166L11.165 13.7764L15.1562 9.97168C15.2131 9.91698 15.2802 9.87399 15.3535 9.84473C15.4273 9.81534 15.5065 9.79983 15.5859 9.7998Z",
    fill: "#0895CB",
    stroke: "#0895CB",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.ef0dcdc3f1523ef65acb119227944278.svg";
export { ForwardRef as ReactComponent };